//frontend/src/dropdownMap/2Act1_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    13: "Gender",
    15: "PWDStatus",
    17: "ExistingBusiness",
    18: "SUNBNMember",
    19: "ContactWithOthers",
    24: "AccessFin",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    ExistingBusiness: {
        internal: ["n", "e"],
        LA: { "n": "ຕັ້ງໃໝ່", "e": "ມີກ່ອນແລ້ວ" },
        EN: { "n": "New", "e": "Existing" }
    },

    SUNBNMember: {
        internal: ["sun_no", "sun_yes"],
        LA: { "sun_no": "No", "sun_yes": "Yes" },
        EN: { "sun_no": "No", "sun_yes": "Yes" }
    },

    ContactWithOthers: {
        internal: ["con_no", "con_yes"],
        LA: { "con_no": "No", "con_yes": "Yes" },
        EN: { "con_no": "No", "con_yes": "Yes" }
    },

    AccessFin: {
        internal: ["fan_no", "fan_yes"],
        LA: { "fan_no": "No", "fan_yes": "Yes" },
        EN: { "fan_no": "No", "fan_yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
